// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2SvvP","fileBtn":"File_fileBtn__3VRWW","closeBtn":"File_closeBtn__3Q2Mg","fileSelected":"File_fileSelected__2nHB0","disabled":"File_disabled__15f2s"};